import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  Badge,
  Spinner,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Form,
  Input,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import "./table.css";

import optionsIcon from "../../assets/tables/optionsIcon.svg";
import printerIcon from "../../assets/tables/printerIcon.svg";
import TulufaliLogo from "../../components/Icons/tulufali_logo.png";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import s from "./Tables.module.scss";

import { API_TIMEOUT, LOKASI, NERACA } from "../../utils/index.js";
import axios from "axios";

import { useDispatch } from "react-redux";

import Success from "../../assets/success.png";
import { logApp, numberWithCommas } from "../../utils/func.js";
import Select, { components } from "react-select";
import swal from "sweetalert";

const TableNeracaMasukGudang_Gudang = function () {
  const [firstTable, setFirstTable] = useState([]);
  const [secondTable, setSecondTable] = useState([]);
  const [lokasi, setLokasi] = useState("");
  const [level, setLevel] = useState("");
  const [puskesmas, setPuskesmas] = useState("");
  const [unit, setUnit] = useState("");

  const [firstTableCurrentPage, setFirstTableCurrentPage] = useState(0);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0);

  const [modalDelete, setModalDelete] = useState(false);

  const currentYear = new Date().getFullYear();
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState(
    currentYear.toString()
  );
  const [bantuanModal, setBantuanModal] = useState("");
  const [tahun, setTahun] = useState(currentYear.toString());

  const [idLok2, setIdLok2] = useState("");

  const [modalSK, setModalSk] = useState(false);
  const [idKunci, setIdKunci] = useState("");

  const [currentUser, setCurrentUser] = useState();
  const [idLokasi, setIdLokasi] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!currentUser) {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      setCurrentUser(currentUser);
      logApp(currentUser.uid, "Neraca Obat Gudang");
      setIdLokasi(currentUser.idLokasi);
    }
  }, []);

  const containerStyle = {
    width: "100%",
    height: "300px", // Atur tinggi sesuai kebutuhan Anda
    overflow: "auto",
    /* Gaya tampilan scroll */
    scrollbarWidth: "thin",
    scrollbarColor: "#888888 #f0f0f0",
  };

  useEffect(() => {
    if (idLokasi) {
      ambilDataLokasi();
      ambilNeracaGudang();
    }
  }, [idLokasi]);

  const ambilDataLokasi = () => {
    axios({
      method: "get",
      url: LOKASI + "ambil/",
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;
          if (data.length > 0) {
            const datafilter = data.filter((item) => {
              return item.level == "Puskesmas" || item.level == "Dinas";
            });
            let lok = [];
            for (var i = 0; i < datafilter.length; i++) {
              lok.push({
                value: datafilter[i].id,
                label: datafilter[i].lokasi,
                color: "primary",
              });
            }

            setLokasi(lok);

            setLevel("Dinas");
          }
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  const ambilNeraca = (id) => {
    setLoading(true);
    axios({
      method: "get",
      url: NERACA + "puskesmas/" + id,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          setLoading(false);
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;

          setFirstTable(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        // ERROR
        setLoading(false);
        alert(error);
      });
  };

  const ambilNeracaGudang = () => {
    setLoading(true);
    axios({
      method: "get",
      url: NERACA + "gudang/",
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          setLoading(false);
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;

          setFirstTable(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        // ERROR
        setLoading(false);
        alert(error);
      });
  };

  const listTahun = [];
  for (let tahun = 2018; tahun <= currentYear; tahun++) {
    listTahun.push({ tahun: tahun });
  }

  const changeSelectDropdownSimple2 = (e) => {
    const select = e.currentTarget.textContent;
    setSimpleDropdownValue2(e.currentTarget.textContent);
    const curAnak = listTahun.filter((item) => {
      return item.tahun == select;
    });

    setTahun(curAnak[0].tahun);
    // ambilDataBantuanKategori(currentBantuan, curAnak[0].tahun);
  };

  const OptionComponent = ({ data, ...props }) => {
    return (
      <components.Option {...props}>
        <div className={`bullet bullet-${data.color} bullet-sm mr-2`}></div>
        {data.label}
      </components.Option>
    );
  };

  const pageSize = 100;
  const pageSize2 = 100;
  const firstTablePagesCount = Math.ceil(firstTable.length / pageSize);
  const secondTablePagesCount = Math.ceil(secondTable.length / pageSize2);

  const setFirstTablePage = (e, index) => {
    e.preventDefault();
    setFirstTableCurrentPage(index);
  };

  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  };

  const openModal = (data) => {
    setModalDelete(true);
  };
  const closeModal = () => {
    setModalDelete(false);
  };

  const openModalSk = (data) => {
    //ambilDataBantuanTahun(data);
    setModalSk(true);
  };
  const closeModalSk = () => {
    setModalSk(false);
  };

  const onChangeLokasi = (data) => {
    setIdLok2([data]);

    if (data.value == 1) {
      ambilNeracaGudang();
    } else {
      ambilNeraca(data.value);
    }
  };

  const getFileName = () => {
    const now = new Date();
    const tanggal = now.toISOString().split("T")[0].replace(/-/g, ""); // Format: YYYYMMDD
    let lokasiNama = "Gudang";

    if (
      idLok2 &&
      Array.isArray(idLok2) &&
      idLok2.length > 0 &&
      idLok2[0] &&
      idLok2[0].label
    ) {
      lokasiNama = idLok2[0].label.replace(/[^a-zA-Z0-9]/g, "_");
    } else if (idLok2 && typeof idLok2 === "string" && idLok2 !== "") {
      lokasiNama = idLok2.replace(/[^a-zA-Z0-9]/g, "_");
    }

    return `Neraca_${lokasiNama}_${tahun}_${tanggal}`;
  };

  const exportToExcel = () => {
    const table = document.getElementById("neraca");
    if (!table) {
      swal("Error", "Tabel tidak ditemukan", "error");
      return;
    }

    const wb = XLSX.utils.table_to_book(table, { sheet: "Data" });
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, getFileName() + ".xlsx");
  };

  const exportToPDF = () => {
    const table = document.getElementById("neraca");
    if (!table) {
      swal("Error", "Tabel tidak ditemukan", "error");
      return;
    }

    const doc = new jsPDF();
    doc.text("Laporan Neraca Gudang", 14, 15);
    doc.text(`Tahun: ${tahun}`, 14, 22);

    const tableData = [];
    const headers = [];

    // Ambil headers
    const thead = table.querySelector("thead");
    if (thead) {
      const headerRows = thead.querySelectorAll("tr");
      headerRows.forEach((row) => {
        const rowData = [];
        row.querySelectorAll("th").forEach((th) => {
          const text = th.textContent.trim();
          if (text) {
            rowData.push(text);
          }
        });
        if (rowData.length > 0) {
          headers.push(rowData);
        }
      });
    }

    // Ambil data
    const tbody = table.querySelector("tbody");
    if (tbody) {
      tbody.querySelectorAll("tr").forEach((row) => {
        const rowData = [];
        row.querySelectorAll("td").forEach((td) => {
          const text = td.textContent.trim();
          rowData.push(text);
        });
        if (rowData.length > 0) {
          tableData.push(rowData);
        }
      });
    }

    if (headers.length > 0 && tableData.length > 0) {
      doc.autoTable({
        head: headers,
        body: tableData,
        startY: 30,
        styles: { fontSize: 7 },
        headStyles: { fillColor: [66, 139, 202] },
      });
    }

    doc.save(getFileName() + ".pdf");
  };

  return (
    <div>
      <Row>
        <Col>
          <Row className="mb-4">
            <Col>
              <Widget>
                <div className={s.tableTitle}>
                  <div className="headline-2">
                    <div>
                      Laporan Neraca #<code>{"Gudang"}</code>
                    </div>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <Button
                      color="success"
                      size="sm"
                      onClick={exportToExcel}
                      className="btnKu"
                      style={{ height: "32px", padding: "0.25rem 0.75rem" }}
                    >
                      <i className="fa fa-file-excel-o mr-2" />
                      Export Excel
                    </Button>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={exportToPDF}
                      className="btnKu"
                      style={{ height: "32px", padding: "0.25rem 0.75rem" }}
                    >
                      <i className="fa fa-file-pdf-o mr-2" />
                      Export PDF
                    </Button>
                  </div>

                  <FormGroup>
                    <Label for="label">Pilih Lokasi Obat</Label>
                    <Select
                      id="label"
                      value={idLok2}
                      options={lokasi}
                      className="react-select"
                      classNamePrefix="select"
                      isClearable={false}
                      onChange={(data) => {
                        onChangeLokasi(data);
                      }}
                    />
                  </FormGroup>

                  <div className="d-flex">
                    <Col className="pr-grid-col" xs={4}>
                      <UncontrolledButtonDropdown>
                        <DropdownToggle caret color="primary">
                          {simpleDropdownValue2}
                        </DropdownToggle>

                        <DropdownMenu>
                          {listTahun &&
                            listTahun.map((item) => (
                              <DropdownItem
                                onClick={changeSelectDropdownSimple2}
                              >
                                {item.tahun}
                              </DropdownItem>
                            ))}
                        </DropdownMenu>
                      </UncontrolledButtonDropdown>
                    </Col>
                  </div>
                </div>
                <div className="widget-table-overflow">
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "200px" }}
                    >
                      <Spinner color="primary" />
                      <span className="ml-3">Memuat data...</span>
                    </div>
                  ) : (
                    <>
                      <Table
                        className={`table-striped table-borderless table-hover ${s.statesTable}`}
                        id="neraca"
                        responsive
                      >
                        <thead>
                          <tr>
                            <th className={s.checkboxCol}>
                              <div className="checkbox checkbox-primary">
                                <input
                                  className="styled"
                                  id="checkbox100"
                                  type="checkbox"
                                />
                                <label for="checkbox100" />
                              </div>
                            </th>
                            <th className="w-25">NAMA</th>

                            <th className="w-25">SUMBER</th>
                            <th className="w-25">TAHUN</th>
                            <th className="w-25">HARGA SATUAN</th>
                            <th className="w-25">STOK AWAL jml</th>
                            <th className="w-25">STOK AWAL Harga</th>
                            <th className="w-25">PENERIMAAN jml</th>
                            <th className="w-25">PENERIMAAN harga</th>

                            <th className="w-25">PENGELUARAN jml</th>
                            <th className="w-25">PENGELUARAN harga</th>
                            <th className="w-25">STOK jml</th>
                            <th className="w-25">STOK harga</th>
                            <th className="w-25">EXPIRED jml</th>
                            <th className="w-25">EXPIRED harga</th>
                          </tr>
                        </thead>
                        <tbody>
                          {firstTable
                            .slice(
                              firstTableCurrentPage * pageSize,
                              (firstTableCurrentPage + 1) * pageSize
                            )
                            .map((item, index) => (
                              <tr key={uuidv4()}>
                                <td>
                                  <div className="checkbox checkbox-primary">
                                    <input
                                      id={index}
                                      className="styled"
                                      type="checkbox"
                                    />
                                    <Label for={index} />
                                  </div>
                                </td>
                                <td className="d-flex align-items-center">
                                  <span className="ml-3">{item.nama}</span>
                                </td>

                                <td>{item.sumber}</td>

                                <td>{item.tahunPengadaan}</td>
                                <td>
                                  Rp.{" "}
                                  {item.harga && numberWithCommas(item.harga)}
                                </td>

                                <td>
                                  {item.stok_awal &&
                                    numberWithCommas(item.stok_awal)}
                                </td>
                                <td>
                                  Rp.{" "}
                                  {item.total_harga_stok_awal &&
                                    numberWithCommas(
                                      item.total_harga_stok_awal
                                    )}
                                </td>
                                <td>
                                  {item.jumlahMasuk
                                    ? numberWithCommas(item.jumlahMasuk)
                                    : item.total_masuk
                                    ? numberWithCommas(item.total_masuk)
                                    : 0}
                                </td>
                                <td>
                                  Rp.
                                  {item.total_harga_masuk &&
                                    numberWithCommas(item.total_harga_masuk)}
                                </td>
                                <td>
                                  {item.total_keluar &&
                                    numberWithCommas(item.total_keluar)}
                                </td>
                                <td>
                                  Rp.
                                  {item.total_harga_keluar &&
                                    numberWithCommas(item.total_harga_keluar)}
                                </td>
                                <td>
                                  {item.stok && numberWithCommas(item.stok)}
                                </td>
                                <td>
                                  Rp.
                                  {item.total_harga_ready &&
                                    numberWithCommas(item.total_harga_ready)}
                                </td>

                                <td>
                                  {item.stok_expired &&
                                    numberWithCommas(item.stok_expired)}
                                </td>

                                <td>
                                  Rp.
                                  {item.total_harga_expired &&
                                    numberWithCommas(item.total_harga_expired)}
                                </td>

                                <td>
                                  <Button
                                    className={`${s.controlBtn} mx-2`}
                                    color="primary"
                                    size="xs"
                                    onClick={() => {
                                      const data = {};

                                      openModal(data);
                                    }}
                                  >
                                    Data
                                  </Button>
                                </td>

                                <td>
                                  <div
                                    className={`d-flex justify-content-between`}
                                  >
                                    <div className="d-flex flex-column mt-3">
                                      <div className={s.activity}>
                                        <p className="body-2">
                                          {Math.round(
                                            (item.total_harga_keluar /
                                              item.total_harga_masuk) *
                                              100
                                          )}
                                          % Penggunaan{" "}
                                        </p>
                                      </div>
                                      <Progress
                                        color={
                                          (item.total_harga_keluar /
                                            item.total_harga_masuk) *
                                            100 >
                                          50
                                            ? "success"
                                            : "danger"
                                        }
                                        className="progress-xs"
                                        value={
                                          (item.total_harga_keluar /
                                            item.total_harga_masuk) *
                                          100
                                        }
                                      />
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                      <Pagination
                        className="pagination-borderless"
                        aria-label="Page navigation example"
                      >
                        <PaginationItem disabled={firstTableCurrentPage <= 0}>
                          <PaginationLink
                            onClick={(e) =>
                              setFirstTablePage(e, firstTableCurrentPage - 1)
                            }
                            previous
                            href="#top"
                          />
                        </PaginationItem>
                        {[...Array(firstTablePagesCount)].map((page, i) => (
                          <PaginationItem
                            active={i === firstTableCurrentPage}
                            key={i}
                          >
                            <PaginationLink
                              onClick={(e) => setFirstTablePage(e, i)}
                              href="#top"
                            >
                              {i + 1}
                            </PaginationLink>
                          </PaginationItem>
                        ))}
                        <PaginationItem
                          disabled={
                            firstTableCurrentPage >= firstTablePagesCount - 1
                          }
                        >
                          <PaginationLink
                            onClick={(e) =>
                              setFirstTablePage(e, firstTableCurrentPage + 1)
                            }
                            next
                            href="#top"
                          />
                        </PaginationItem>
                      </Pagination>
                    </>
                  )}
                </div>
              </Widget>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal size="lg" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>
          <div className={s.tableTitle}>
            <div className="headline-2">
              {bantuanModal}
              <code> Tahun {tahun}</code>
            </div>
            <div className="d-flex">
              <Button
                color="success"
                size="sm"
                onClick={() => {
                  const table = document.getElementById("dataBantuan");
                  if (!table) {
                    swal("Error", "Tabel tidak ditemukan", "error");
                    return;
                  }
                  const wb = XLSX.utils.table_to_book(table, { sheet: "Data" });
                  const excelBuffer = XLSX.write(wb, {
                    bookType: "xlsx",
                    type: "array",
                  });
                  const data = new Blob([excelBuffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  const now = new Date();
                  const tanggal = now
                    .toISOString()
                    .split("T")[0]
                    .replace(/-/g, "");
                  saveAs(
                    data,
                    "TuluFali_Data_Bansos_" +
                      bantuanModal.replace(/[^a-zA-Z0-9]/g, "_") +
                      "_" +
                      tahun +
                      "_" +
                      tanggal +
                      ".xlsx"
                  );
                }}
                className="btnKu"
                style={{ height: "32px", padding: "0.25rem 0.75rem" }}
              >
                <i className="fa fa-file-excel-o mr-2" />
                Excel
              </Button>
              <Button
                color="danger"
                size="sm"
                onClick={() => {
                  const table = document.getElementById("dataBantuan");
                  if (!table) {
                    swal("Error", "Tabel tidak ditemukan", "error");
                    return;
                  }
                  const doc = new jsPDF();
                  doc.text("TuluFali Data Bansos", 14, 15);
                  doc.text(`Tahun: ${tahun}`, 14, 22);

                  const tableData = [];
                  const headers = [];

                  const thead = table.querySelector("thead");
                  if (thead) {
                    const headerRows = thead.querySelectorAll("tr");
                    headerRows.forEach((row) => {
                      const rowData = [];
                      row.querySelectorAll("th").forEach((th) => {
                        const text = th.textContent.trim();
                        if (text) {
                          rowData.push(text);
                        }
                      });
                      if (rowData.length > 0) {
                        headers.push(rowData);
                      }
                    });
                  }

                  const tbody = table.querySelector("tbody");
                  if (tbody) {
                    tbody.querySelectorAll("tr").forEach((row) => {
                      const rowData = [];
                      row.querySelectorAll("td").forEach((td) => {
                        const text = td.textContent.trim();
                        rowData.push(text);
                      });
                      if (rowData.length > 0) {
                        tableData.push(rowData);
                      }
                    });
                  }

                  if (headers.length > 0 && tableData.length > 0) {
                    doc.autoTable({
                      head: headers,
                      body: tableData,
                      startY: 30,
                      styles: { fontSize: 7 },
                      headStyles: { fillColor: [66, 139, 202] },
                    });
                  }

                  const now = new Date();
                  const tanggal = now
                    .toISOString()
                    .split("T")[0]
                    .replace(/-/g, "");
                  doc.save(
                    "TuluFali_Data_Bansos_" +
                      bantuanModal.replace(/[^a-zA-Z0-9]/g, "_") +
                      "_" +
                      tahun +
                      "_" +
                      tanggal +
                      ".pdf"
                  );
                }}
                className="btnKu"
                style={{ height: "32px", padding: "0.25rem 0.75rem" }}
              >
                <i className="fa fa-file-pdf-o mr-2" />
                PDF
              </Button>
              <a>
                <img src={printerIcon} alt="Printer" />
              </a>
              <a>
                <img
                  className="d-none d-sm-block"
                  src={optionsIcon}
                  alt="Options"
                />
              </a>
              <a>
                <img
                  style={{ width: 30, height: 30 }}
                  src={Success}
                  alt="Funnel"
                />
              </a>
            </div>
          </div>
        </ModalHeader>

        <Widget className="widget-p-md">
          <div className="widget-table-overflow">
            <Table
              id="dataBantuan"
              className={`table-striped table-borderless table-hover ${s.statesTable}`}
              responsive
            >
              <thead>
                <tr>
                  <th className="w-15">TL</th>
                  <th className="w-25">Nama</th>
                  <th className="w-25">Kelompok</th>
                  <th className="w-25">NIK</th>
                  <th className="w-25">Status</th>
                  <th className="w-25">Desa</th>

                  <th className="w-25">Kecamatan</th>
                </tr>
              </thead>
              <tbody>
                {secondTable
                  .slice(
                    secondTableCurrentPage * pageSize2,
                    (secondTableCurrentPage + 1) * pageSize2
                  )
                  .map((item) => (
                    <tr key={uuidv4()}>
                      <td className="d-flex align-items-center">
                        <img
                          className={s.image}
                          src={TulufaliLogo}
                          alt="User"
                        />
                        <span className="ml-3">{item.name}</span>
                      </td>

                      <td>{item.nama}</td>
                      <td>{item.kelompok}</td>
                      <td>{item.nik}</td>
                      <td>
                        <code>
                          {item.idKeluarga != ""
                            ? " miskin ekstrim "
                            : " mampu "}
                        </code>
                      </td>
                      <td>{item.desa}</td>
                      <td>{item.kecamatan}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            <Pagination
              className="pagination-borderless"
              aria-label="Page navigation example"
            >
              <PaginationItem disabled={secondTableCurrentPage <= 0}>
                <PaginationLink
                  onClick={(e) =>
                    setSecondTablePage(e, secondTableCurrentPage - 1)
                  }
                  previous
                  href="#top"
                />
              </PaginationItem>
              {[...Array(secondTablePagesCount)].map((page, i) => (
                <PaginationItem active={i === secondTableCurrentPage} key={i}>
                  <PaginationLink
                    onClick={(e) => setSecondTablePage(e, i)}
                    href="#top"
                  >
                    {i + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem
                disabled={secondTableCurrentPage >= secondTablePagesCount - 1}
              >
                <PaginationLink
                  onClick={(e) =>
                    setFirstTablePage(e, secondTableCurrentPage + 1)
                  }
                  next
                  href="#top"
                />
              </PaginationItem>
            </Pagination>
          </div>
        </Widget>
      </Modal>
    </div>
  );
};

export default TableNeracaMasukGudang_Gudang;
